export default "__VITE_ASSET__BM50rUrW__"